// http://www.csvjson.com/csv2json
import { PillarArticleModel } from "./PillarModel";

export const ContentArticlesModel: PillarArticleModel[] = [
  {
    pillarId: 0,
    storyId: 16,
    title: "A star's reborn",
    text:
      "It's the reboot we've all been hanging out for. The Subaru XV has been reimagined and redesigned for today's audience.",
    imageUrl: "16_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 39,
    title: "red carpet access",
    text:
      "The Subaru XV knows when you're nearby, unlocking the car when you touch the door handle. So you can keep your keys in your pocket.",
    imageUrl: "39-Headline_Img_680x382.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 99,
    title: "gripping scenes",
    text: "With the flick of a button, the XV holds tight with its electronic parking brake!",
    imageUrl: "99_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 103,
    title: "SONAR SENSORS",
    text:
      "Enjoy greater peace of mind when reversing with four sonar sensors installed on the rear bumper. They detect obstructions and alert the driver if there's a risk of an impact, then apply the brakes automatically if needed.",
    imageUrl: "103-Headline_Img_680x3822.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 37,
    title: "cut means cut",
    text:
      "When you stop, we stop. Our Auto Stop Start tech can save fuel by cutting the engine when you don't need it. Good for the environment and good for your wallet.",
    imageUrl: "",
    videoUrl: "37.mp4"
  },
  {
    pillarId: 0,
    storyId: 38,
    title: "press play",
    text: "The engine kicks in with a single button, like pressing play on your favourite film.",
    imageUrl: "38_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 40,
    title: "call the shots",
    text:
      "Using simple voice commands, you can make handsfree calls from your phone. That means it's safe for you to keep rolling.",
    imageUrl: "40-Headline_Img_680x3823.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 89,
    title: "a light show when you pause",
    text:
      "If you brake suddenly at high speeds, the XV's hazard lamps flash rapidly to warn the vehicle behind you, giving them time to hit the brakes too.",
    imageUrl: "89-Headline_Img_680x3824.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 43,
    title: "choose your speed",
    text:
      "Every XV will have paddle gear shifters on the steering wheel, so you have the option of driving in Lineartronic CVT™ or for even more fun and control, 7-speed manual mode.",
    imageUrl: "43_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 60,
    title: "BEST CABLE ENTERTAINMENT",
    text:
      "Your car, your music. With USB and AUX connectivity, you can set the soundtrack to every journey.",
    imageUrl: "60_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 32,
    title: "",
    text:
      "Subaru’s legendary Symmetrical All-Wheel Drive System delivers drive distribution to all four wheels, all the time. This gives you more grip, balance and control.",
    imageUrl: "32-Trophy_SAWD.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 44,
    title: "the less hurt locker",
    text:
      "Our front seat belts now have a locking tongue which limits movement in the lap belt and reduces the load to the lower chest. It’s a safer safety belt.",
    imageUrl: "44-Headline_Img_680x3825.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 46,
    title: "BEST SUPPORTING ANCHOR POINTS",
    text:
      "With the latest in ISOFIX child seat anchor points, XV has features designed to keep all passengers as safe as can be, regardless of their size.",
    imageUrl: "46_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 81,
    title: "blockbuster brakes",
    text:
      "The XV 2.0i-S has the looks to match the performance, right down to the footwear. Aluminium sports pedals mean even your feet feel sporty.",
    imageUrl: "81-Headline_Img_680x3829.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 82,
    title: "BEST SPECIAL EFFECTS",
    text:
      "Pop-up washer jets keep the XV 2.0i-S LED lights clear, giving you the best view of the show ahead.",
    imageUrl: "82_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 92,
    title: "wind machine",
    text:
      "With more vent outlet modes than ever before, you can send air wherever you want it, keeping you cool and comfortable.",
    imageUrl: "92-Headline_Img_680x3826.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 95,
    title: "seeing searchlights",
    text:
      "Dynamically designed fog lamps fit beautifully on the XV, and they're a stand-out performer when you need them to be.",
    imageUrl: "95_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 0,
    storyId: 96,
    title: "tear jerker",
    text:
      "Flat wiper blades in the XV keep a lower profile than previous designs, so they won't get in the way while they keep the rain at bay.",
    imageUrl: "96-Headline_Img_680x38210.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 24,
    title: "don't hog the spotlight",
    text:
      "With EyeSight® technology, when the car in front of you moves at a green light, we’ll let you know it’s time to go. So the driver behind you doesn't have to.",
    imageUrl: "24_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 61,
    title: "from the director's chair",
    text:
      "From changing the volume, to using EyeSight® to increase the distance to the car in front, stay in control of the show with the touch of a button.",
    imageUrl: "61.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 13,
    title: "centre stage",
    text:
      "With the XV's rear view camera mounted near the centre of the body, objects are displayed more realistically, making it easier to reverse into tight spots.",
    imageUrl: "13-Headline_Img_680x38211.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 33,
    title: "stick to the red carpet",
    text:
      "Sensors monitor your car’s intended line through curves, adjusting braking and power to prevent skidding and keep you in control.",
    imageUrl: "33_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 55,
    title: "light up the screen",
    text:
      "Sharp, focused, steering responsive LED headlights follow your lead. So when you turn, they turn.",
    imageUrl: "55_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 105,
    title: "DIM THE LIGHTS",
    text:
      "With High Beam Assist, head lamps automatically switch between high beams and low beams to suit changing conditions in front of your car, helping to improve visibility at night.",
    imageUrl: "105.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 52,
    title: "all spotlights covered",
    text:
      "Subaru's Vision Assist technology means you'll never be driving blind. The system detects if a vehicle is in your blind spot and lets you know to watch out.",
    imageUrl: "52.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 53,
    title: "",
    text:
      "If the system detects that vehicles are approaching from the side while you are reversing, our Vision Assist rear cross traffic alert will alert you that there is risk of a collision.",
    imageUrl: "53-Trophy_BPA.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 35,
    title: "",
    text:
      "Subaru innovation isn't limited to just handling. Cutting-edge design also makes a Subaru one of the safest cars on the road, and we anticipate the XV to be awarded the maximum 5 star ANCAP safety rating.",
    imageUrl: "35-Headline_Img_680x3827.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 20,
    title: "follow their lead",
    text:
      "Subaru’s EyeSight® technology features Adaptive Cruise Control, which tracks the vehicle in front of you, keeping a safe distance to take the stress off having that unpredictable diva ahead.",
    imageUrl: "20.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 27,
    title: "blooper prevention",
    text:
      "If the accelerator is pushed by accident when an object is detected in front, our EyeSight® Driver Assist technology restricts engine power to help reduce the impact.",
    imageUrl: "27-Headline_Img_680x38214.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 29,
    title: "stars in your EyeSight®",
    text:
      "The Adaptive Cruise Control notices when a car in front of you brakes, gently slowing to match their speed.",
    imageUrl: "29.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 28,
    title: "greater direction on the road",
    text:
      "Our EyeSight® Driver Assist technology's Pre-Collision Steering Assist applies greater steering assistance when you attempt to steer away from a detected collision ahead.",
    imageUrl: "28_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 54,
    title: "pumped performance",
    text:
      "Every XV has a clever system that detects when tyre pressure is low, and lets you know. So you can pump them up before it's too late. It'll mean they'll last longer than the opening credits.",
    imageUrl: "54-Headline_Img_680x38215.jpg",
    videoUrl: ""
  },
  {
    pillarId: 2,
    storyId: 62,
    title: "screen queens",
    text:
      'Extra large touchscreens (ranging from 6.5" to 8") make it super easy for you to do everything from changing the radio station, to navigating your way home.',
    imageUrl: "62_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 2,
    storyId: 8,
    title: "we'll help read your lines",
    text:
      "XV's Apple CarPlay™ and Android Auto™ technology reads your text messages out loud, and even gives you weather updates, so you can focus on the scene around you.",
    imageUrl: "8_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 2,
    storyId: 58,
    title: "connecting the cast",
    text:
      "All of our technology works together, with information displayed on three internal screen as it's needed.",
    imageUrl: "58_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 2,
    storyId: 83,
    title: "",
    text:
      "Sing along to your favourite soundtrack with six individual speakers delivering crystal clear sound.",
    imageUrl: "83-Trophy_BSD.jpg",
    videoUrl: ""
  },
  {
    pillarId: 2,
    storyId: 10,
    title: "just like your small screen",
    text:
      "The XV will have a touchscreen you can touch, swipe and pinch, just like your smartphone.",
    imageUrl: "10_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 2,
    storyId: 31,
    title: "the real big screen",
    text:
      "Our 6.3” colour LCD screen puts your driving on display, translating useful vehicle information into entertaining, easy to understand graphics.",
    imageUrl: "31_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 102,
    title: "Next Big thing",
    text: "The Subaru XV rides high above the rough stuff with 220mm of ground clearance.",
    imageUrl: "102_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 30,
    title: "easy to see",
    text:
      "Vital vehicle information is provided on a beautifully designed and easy to read display.",
    imageUrl: "30_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 104,
    title: "Carry the scene",
    text:
      "The roof rails feature a simple, stylish design made up of a single, curved piece of aluminium. The available space to install a carrier has also been increased by 15% for better usability.",
    imageUrl: "104_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 1,
    title: "Star struck",
    text:
      "The sunroof operating mechanism has been redesigned so it's thinner, lighter and creates less drag, so you can enjoy the sun and stars.",
    imageUrl: "1.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 48,
    title: "big wheels",
    text:
      "Impressive 17\" and 18” wheels are coming to the XV, reducing vibrations and road noise, while gripping the road. Lookin' good, drivin' great.",
    imageUrl: "48_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 50,
    title: "quiet on set",
    text:
      "The speed at which your windows shut reduces just prior to fully closing, ensuring a smooth, soft close.",
    imageUrl: "50.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 51,
    title: "mirror, mirror on the door",
    text:
      "XV door mirrors do more than the obvious. Aerodynamic with an even quieter power-folding motor, they increase driving comfort with both function and form.",
    imageUrl: "51_V3.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 77,
    title: "hold this for me",
    text: "With two perfectly placed cup holders in front, your coffee will be as safe as you are.",
    imageUrl: "77_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 78,
    title: "",
    text: "With a wide range of colours to choose from, it’s easy to pick a XV that suits you.",
    imageUrl: "78-Trophy_VAFCO.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 84,
    title: "natural born driver",
    text:
      "With a greater range of tilt and telescopic  adjustment in the steering column, the XV puts the controls right where you want them.",
    imageUrl: "84-Headline_Img_680x38226.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 79,
    title: "grab an extra popcorn",
    text: "The XV comes with extra-comfy armrests and plenty of space for your snacks.",
    imageUrl: "",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 94,
    title: "a spectacular entrance",
    text:
      "Make a red-carpet entrance with doors that've been engineered for more room to move as you get in and out.",
    imageUrl: "94-Headline_Img_680x3828.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 100,
    title: "grab an extra popcorn for your mates",
    text:
      "Passengers can also hit the snack stand with a pull-down arm rest that sits in the middle of the rear seats.",
    imageUrl: "100.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 3,
    title: "the dark night light",
    text:
      "The XV's stop lamp has been mounted to the lower edge of the roof spoiler. This achieves a great balance between visibility, aerodynamic performance and design.",
    imageUrl: "3-Headline_Img_680x38222.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 12,
    title: "some like it warm",
    text: "Easy to reach seat heating controls mean comfort is close at hand.",
    imageUrl: "12-Headline_Img_680x38224.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 2,
    title: "get the lot",
    text:
      "The XV's body width has been increased by 35mm, which gives you a sportier design and more spacious cabin.",
    imageUrl: "2_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 91,
    title: "location location location",
    text:
      "Functional interior design puts everything in the right place. So you can stress less, finding the controls and equipment you're looking for, without taking your eyes off the road.",
    imageUrl: "91_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 98,
    title: "dream screen",
    text:
      "The molding on the front windscreen glass is recessed, giving you a sleeker window design to look out of, and at.",
    imageUrl: "98_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 101,
    title: "not an actor",
    text:
      "Introducing X-Mode. It improves drivability by providing better control over components like the engine, AWD, and brakes. For example, the hill descent control feature keeps the vehicle at a constant speed on steep, slippery, downhill surfaces.For example, the hill descent control feature keeps the vehicle at a constant speed on steep, slippery, downhill surfaces.",
    imageUrl: "101_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 17,
    title: "like grease lightning",
    text:
      "Thanks to brilliant scientific advances you'll get more power and efficiency from the Subaru XV's direct injection Boxer engine.",
    imageUrl: "",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 80,
    title: "own the role",
    text:
      "The XV lets you switch to manual mode. So when you hit a curve in the road, it’s time to take control, shifting gears with the steering wheel paddle gear shifters.",
    imageUrl: "80_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 18,
    title: "Legendary performance",
    text:
      "With 115kW of power and direct injection technology, the XV gives you more power to match its sleek look.",
    imageUrl: "18-Headline_Img_680x38216.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 45,
    title: "Act fast",
    text:
      "Every XV comes with pressure sensors in the front doors to increase the speed at which an impact is detected and the airbags deployed.",
    imageUrl: "45-Headline_Img_680x38217.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 6,
    title: "",
    text:
      "We've reduced high frequency engine and transmission sounds, as well as road noises. So you can listen to music, chat, or just enjoy the peace.",
    imageUrl: "6-Trophy_WSP.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 34,
    title: "Moving star",
    text:
      "The XV directs power to its outer wheels so the car turns better on sharp city corners, and you own the road like the star you are.",
    imageUrl: "34.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 88,
    title: "director's cut-through",
    text:
      "Ingenious design has increased the aerodynamic qualities of the XV's body, so you're always on the path of least resistance.",
    imageUrl: "88_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 15,
    title: "red carpet ready",
    text:
      "The XV has an body structure. It’s now even better at absorbing energy in a prang, which means it is safer and more durable.",
    imageUrl: "15.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 19,
    title: "",
    text:
      "No matter the conditions, you’re in for a smooth ride with your XV's Lineartronic™ CVT, auto stepped speed control and 7-speed manual mode standard in all models.",
    imageUrl: "19-Trophy_NFBP.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 23,
    title: "Steady cam",
    text:
      "The increase in engine revs when you shift down a gear has been reduced, giving you acceleration that's smooth and satisfying.",
    imageUrl: "23_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 36,
    title: "performs in every scene",
    text:
      "With our Vehicle Dynamics Control system, braking pressure is regulated for each individual wheel, so they won't lock up when you brake in a hurry making you a better performer.",
    imageUrl: "36.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 47,
    title: "Sound editing",
    text:
      "The Subaru Global Platform's suspension mounts limit vibration and noise transfer, while improving control and stability, for a ride that's easy on the road, and the ears.",
    imageUrl: "47.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 57,
    title: "Great material",
    text:
      "By using aluminium instead of steel for the hood, we've cut 5.2kg of weight from the XV. It also makes it easier for you to admire the engine.",
    imageUrl: "57-Headline_Img_680x38218.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 72,
    title: "take the lead",
    text:
      "The Subaru Global Platform gives the XV improved directional control. That means you can be more responsive, and avoid hazards more easily.",
    imageUrl: "72_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 73,
    title: "safe side story",
    text:
      "The Subaru Global Platform uses structures of varying strengths to absorb energy in all the right places, which helps to keep you safer.",
    imageUrl: "73_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 74,
    title: "",
    text:
      "Continuous spot welding gives the Subaru Global Platform increased joint strength, keeping you and your passengers protected.",
    imageUrl: "74-Trophy_SSC.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 85,
    title: "the hand that rocks the XV",
    text:
      "By reducing the steering ratio, we've improved the handling in the XV, so you and your car turn as one.",
    imageUrl: "85_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 86,
    title: "good vibrations",
    text:
      "We've optimised the dampers, reducing bad vibrations while improving handling and comfort. That's good vibrations.",
    imageUrl: "86.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 87,
    title: "Show stopper",
    text:
      "High friction brake pads and next-gen calipers put some pep in your step. When your foot goes down, the car responds, giving you confidence and control.",
    imageUrl: "87-Headline_Img_680x38221.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 106,
    title: "Stay on your Mark",
    text:
      "The Subaru XV won’t let you stray too far from script. If the vehicle’s EyeSight® Driver Assist technology senses lane sway or lane departure, it’ll warn you, helping you to avoid stepping on someone else’s line.",
    imageUrl: "21.jpg",
    videoUrl: ""
  },
  {
    pillarId: 1,
    storyId: 107,
    title: "Your big brake",
    text:
      "Our EyeSight® Driver Assist technology can warn you of imminent impact. It also senses if you’re not acting fast enough – applying more stopping power as needed",
    imageUrl: "107_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 2,
    storyId: 108,
    title: "Give directions",
    text:
      "To switch radio stations, play the next song on your soundtrack or lock in your directions, just hit voice command and say the magic words.",
    imageUrl: "",
    videoUrl: "108.mp4"
  },
  {
    pillarId: 2,
    storyId: 109,
    title: "Phone it in",
    text:
      "Seamlessly connect your Subaru XV to your smartphone with Apple Carplay™ or Android Auto™. Higher spec XVs come equipped with an excellent Satellite Navigation System, but cleverly, you can also bounce your smartphone’s mapping system to the XVs big screen whenever you like.",
    imageUrl: "9.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 110,
    title: "record opening",
    text:
      "Dual-zone climate control allows the driver and passenger to set their own temperatures and more ventilation brings the XV cabin to a more uniform temperature quicker. You can even control the system with your voice.",
    imageUrl: "",
    videoUrl: "110.mp4"
  },
  {
    pillarId: 3,
    storyId: 111,
    title: "",
    text:
      "The Subaru XV’s boot opening has been enlarged and the wheel housings have been widened to make it easier to put a whole lot more of your stuff in.",
    imageUrl: "111_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 3,
    storyId: 112,
    title: "Beautiful lighting",
    text:
      "The sharper, more streamlined halogen headlights of the Subaru XV with a distinctive C-shaped accent are as functional as they are beautiful. The top spec XV includes Steering Responsive Headlights that follow your every move. Lights, cameras, action! Subaru XV has it all.",
    imageUrl: "",
    videoUrl: "112.mp4"
  },
  {
    pillarId: 4,
    storyId: 113,
    title: "Gold class seats",
    text:
      "Our designers haven’t been sitting on their hands. They’ve taken the science of ergonomics to new levels with multiple improvements from upholstery to lumbar support. We’ve even given more leg space to those sitting in the row behind you.",
    imageUrl: "90.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 114,
    title: "Core balance",
    text:
      "Every XV comes with an amazing core. The Subaru Global Platform is the reason the Subaru XV has improved straight line stability and can respond instantly to any steering change, allowing you to execute your drive while keeping the car on its intended line.",
    imageUrl: "114_V2.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 115,
    title: "Core power",
    text:
      "Every XV comes with an amazing core. The Subaru Global Platform is the reason the Subaru XV delivers high-response handling. Turn the wheel and the car responds willingly, with a feeling of supreme driving ease, just as you’d expect. We’ve narrowed the time between steer and response. So you can enjoy an instant response to every impulse.",
    imageUrl: "115.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 116,
    title: "Core strength",
    text:
      "Every XV comes with an amazing core. The Subaru Global Platform, is the reason the XV is so incredibly strong. Greater uses of high strength steel panels, hot pressed moulded materials and a structure designed for more efficient energy absorption. We’re keeping pace with the future for ultimate peace of mind.",
    imageUrl: "70.jpg",
    videoUrl: ""
  },
  {
    pillarId: 4,
    storyId: 117,
    title: "Core future",
    text:
      "The XV comes with a state of the art core. The Subaru Global Platform makes the Subaru XV more balanced, more powerful, safer and stronger than ever before. It’s the future-ready foundation for all Subaru’s to come. So no matter where our imagination leads us, we will always deliver to our core strengths.",
    imageUrl: "117.jpg",
    videoUrl: ""
  }
];
